<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!isResend()">Invite Waitlist Entry To Book</h4>
    <h4 class="modal-title" *ngIf="isResend()">Resend Invitation</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p *ngIf="isResend()">
      This will send <b>{{ waitlistEntry.first_name }} {{ waitlistEntry.last_name }}</b>
      the same invitation again, to book the <b>{{ waitlistEntry.event_type_name }}</b>.
      Their entry stays pending.
    </p>

    <ng-container *ngIf="waitlistScheduledEvent === null">

      <ng-container *ngIf="!loadingSelectedEvent && !selectedEvent">

        <p>Select a Time Slot</p>

        <div class="mb-2">
          <app-date-picker [id]="'selectedDate'"
                           [(content)]="selectedDate"
                           (contentChange)="loadEventsForDate()"
                           [small]="true"></app-date-picker>
        </div>

        <div class="rounded-table-wrapper rounded-table-tight">
          <table class="table table-sm">
            <thead>
            <tr>
              <th scope="col">Time</th>
              <th scope="col">R/C</th>
              <th scope="col">Location</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="!loadingEventsForDate">
              <tr *ngFor="let scheduledEvent of scheduledEventsForDate">
                <td>
                  {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
                  {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
                  <span *ngIf="scheduledEvent.is_cancelled">&ndash; <b>Cancelled</b></span>
                  <ng-container *ngIf="scheduledEvent.event_part_count > 1">
                    <br>
                    (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
                  </ng-container>
                  <ng-container *ngIf="scheduledEvent.schedule_name">
                    <br>
                    <i>{{ scheduledEvent.schedule_name }}</i>
                  </ng-container>
                  <ng-container *ngIf="scheduledEvent.customer_facing_name && (scheduledEvent.customer_facing_name !== scheduledEvent.schedule_name)">
                    <br>
                    <i>{{ scheduledEvent.customer_facing_name }}</i>
                  </ng-container>
                </td>
                <td>
                  <span placement="bottom" style="white-space: nowrap"
                        [ngbTooltip]="eventFullDueToSecondaryCapacity(scheduledEvent) ? 'Facility capacity or booking limit reached for this time slot.' : ''">
                    {{ scheduledEvent.reservation_count }} / {{ scheduledEvent.capacity }}
                    <span *ngIf="eventFullDueToSecondaryCapacity(scheduledEvent)">*</span>
                  </span>
                </td>
                <td>
                  {{ scheduledEvent.location_name }}
                </td>
                <td class="table-sm-button-cell">
                  <button class="btn btn-sm btn-outline-primary table-sm-button float-right"
                          type="button"
                          (click)="loadSelectedEvent(scheduledEvent.event_id)">
                    Select
                  </button>
                </td>
              </tr>
              <tr *ngIf="scheduledEventsForDate.length === 0">
                <td colspan="99">No time slots for the selected date</td>
              </tr>
            </ng-container>
            <tr *ngIf="loadingEventsForDate">
              <td colspan="99">Loading...</td>
            </tr>
            </tbody>
          </table>
        </div>

      </ng-container>

      <ng-container *ngIf="loadingSelectedEvent">
        <p class="text-muted">
          Loading event...
        </p>
      </ng-container>

      <ng-container *ngIf="!loadingSelectedEvent && selectedEvent">
        <button class="btn btn-sm btn-link float-right" style="margin-top: -6px"
                type="button"
                [disabled]="loadingSubmit"
                [class.disabled]="loadingSubmit"
                (click)="selectedEvent = null">
          Clear Selection
        </button>

        <ng-container *ngIf="selectedEvent.event_parts.length === 1">
          <p>
            Selected Event at {{ selectedEvent.location_name }}:
            <b>
              {{ selectedEvent.event_parts[0].start_local_date }},
              {{ selectedEvent.event_parts[0].start_local_time }} -
              {{ selectedEvent.event_parts[0].end_local_time }}
            </b>
          </p>
        </ng-container>
        <ng-container *ngIf="selectedEvent.event_parts.length > 1">
          <p class="mb-1">
            Selected multi-part event at {{ selectedEvent.location_name }}:
          </p>
          <ul>
            <li *ngFor="let eventPart of selectedEvent.event_parts">
              <b>
                {{ eventPart.start_local_date }},
                {{ eventPart.start_local_time }} -
                {{ eventPart.end_local_time }}
              </b>
            </li>
          </ul>
        </ng-container>
      </ng-container>

    </ng-container>

    <div class="mb-3">
      <a href="#" class="float-right"
         *ngIf="newDeadlineDate || newDeadlineTime"
         (click)="$event.preventDefault(); handleClearNewDeadline();">
        Clear
      </a>
      <label class="form-text" for="newDeadlineDate">
        {{ isResend() ? 'New Booking Deadline (optional)' : 'Booking Deadline (optional)' }}
      </label>
      <app-deadline-date-time-input [idPrefix]="'newDeadline'"
                                    [timeZone]="deadlineTimeZone()"
                                    [(date)]="newDeadlineDate"
                                    [(time)]="newDeadlineTime"></app-deadline-date-time-input>
      <small class="form-text text-muted"
             *ngIf="isResend() && waitlistEntry.booking_deadline">
        Leave this blank to keep the current deadline of
        {{ dateStringFromISO8601(waitlistEntry.booking_deadline, waitlistEntry.time_zone) }},
        {{ timeStringFromISO8601(waitlistEntry.booking_deadline, waitlistEntry.time_zone) }}.
      </small>
      <small class="form-text text-muted"
             *ngIf="isResend() && !waitlistEntry.booking_deadline">
        This entry currently has no deadline. Leave this blank to keep it that way.
      </small>
      <small class="form-text text-muted"
             *ngIf="!isResend()">
        Leave this blank to use the event type's default acceptance window. If the event type has none, the invitation will not expire.
      </small>
      <small class="form-text text-danger"
             *ngIf="newDeadlineIncomplete()">
        Enter both a date and a time for the new deadline.
      </small>
    </div>

    <div class="form-group">
      <label>Invite Note (optional)</label>
      <app-markdown-editor [id]="'inviteNote'"
                           [(content)]="inviteNote"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        This text will be included in the invitation, underneath information about
        the event and (if set above) the booking deadline. It is prefilled with the
        note from this entry's last invitation, if there was one; clearing it sends
        the invitation with no note.
      </small>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               id="sendInviteToParentsAndGuardians"
               name="sendInviteToParentsAndGuardians"
               [disabled]="loadingSubmit"
               [class.disabled]="loadingSubmit"
               [(ngModel)]="sendInviteToParentsAndGuardians">
        <label class="form-check-label"
               for="sendInviteToParentsAndGuardians">
          Send invite to linked parents &amp; guardians
        </label>
      </div>
      <small class="form-text text-muted">
        If selected, the invite will be sent to any linked parents and guardians of the participant to accept or reject the invite on behalf of the participant. This is in addition to the participant's own email address.
      </small>
    </div>

    <div class="alert alert-danger" role="alert"
         *ngIf="hasNoEmailRecipient() && !loadingRelations">
      <b>{{ waitlistEntry.first_name }} {{ waitlistEntry.last_name }}</b> has no
      email address on file, so <b>no email will actually be sent</b>. The
      invitation will still be recorded, and they can still be booked in by
      staff, but they will not be notified.
    </div>

    <p *ngIf="emailRecipients().length > 0">
      This will send an email to
      <b *ngFor="let recipient of emailRecipients(); let last = last">{{ recipient }}{{ last ? '' : ', ' }}</b>
      inviting them to book the <b>{{ waitlistEntry.event_type_name }}</b> for <b>{{ waitlistEntry.first_name }} {{ waitlistEntry.last_name }}.</b>
    </p>

    <app-age-restriction-bypass-warning [violations]="ageRestriction.violations"
                                        [(acknowledged)]="ageRestriction.acknowledged"
                                        [disabled]="loadingSubmit"></app-age-restriction-bypass-warning>

    <div class="alert alert-warning" role="alert"
         *ngIf="(waitlistScheduledEvent !== null) && (waitlistScheduledEvent.remaining_capacity <= 0)">
      This event has no remaining capacity. By sending this invite, you will bypass the capacity limit, and if the invite is accepted, the event will go over capacity.
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            [disabled]="submitDisabled()"
            [class.disabled]="submitDisabled()"
            (click)="handleSendInvite()">
      {{ isResend() ? 'Resend Invitation' : 'Send Invite' }}
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
